import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
export default function RightIcon() {
  return (
    <>
      <StaticImage
        loading="eager"
        src="../../../../images/top-strip/flag-right.png"
        placeholder="blurred"
        className="hidden w-[110px] self-end md:block"
        layout="fullWidth"
        alt="LeftIcon"
      />
      <StaticImage
        loading="eager"
        src="../../../../images/top-strip/flag-right-mobile.png"
        placeholder="blurred"
        className="block w-[80px] self-end md:hidden"
        layout="fullWidth"
        alt="Icon"
      />
    </>
  );
}
